// extracted by mini-css-extract-plugin
export default {"deckName":"decks_deckName__3gODO","deckLegend":"decks_deckLegend__F94DT","belowDeck":"decks_belowDeck__pFy3M","totalCount":"decks_totalCount__Ix+RN"};